import React, { useEffect } from 'react'

import styled from 'styled-components'

import { AppNavigator } from '../../components/AppNavigator'
import { FadeIn } from '../../components/FadeIn'
import { Button } from '../../components/Button'
import { useAuthContext } from '../../contexts'
import { useHistory } from 'react-router-dom'
import { trackAdminPortalScreenViewedPayload } from '../../../generated/trackingEvents'
import { track } from '../../utils/log'

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: flex-start;
  width: 100%;
  padding: 30px 50px;
`

const MessageContainer = styled.div`
  margin: 80px;
`

const Message = styled.h1`
  margin: 0 0 40px 0;
`

const Home = () => {
  const { adminUser } = useAuthContext()

  const history = useHistory()

  useEffect(() => {
    if (adminUser?.id) {
      const [eventName, payload] = trackAdminPortalScreenViewedPayload()
      track(eventName, payload, adminUser?.id)
    }
  }, [adminUser?.id])

  return (
    <Container>
      {adminUser && (
        <MessageContainer>
          <FadeIn style={{ textAlign: 'center' }}>
            <Message>Welcome, {adminUser.firstName}</Message>

            <Button onClick={() => history.push('/logout')}>Not you?</Button>
          </FadeIn>
        </MessageContainer>
      )}

      <AppNavigator />
    </Container>
  )
}

export { Home }
